import React from "react";
import {css, useTheme} from "@emotion/react";

import {flex, mt, p, pl, prettyScroll, pv} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";
import {SelectGroupField} from "@pg-design/select-group-module";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {
    investmentOfferHolidayTypes,
    InvestmentOfferSubCategory,
    investmentOfferTypes,
    InvestmentOfferTypeSlug
} from "../../constants/investment_offer_constants";
import {IInvestmentOfferListFiltersFields} from "../../hooks/use_investment_offer_filters";
import {getInvestmentOffersSubCategoryOptions} from "../utils/get_investment_offers_subcategory_options";

interface IProps extends IFormProps<IInvestmentOfferListFiltersFields> {
    onReset: () => void;
    onSave: () => void;
}

const CATEGORY_FILTER_NAME = "category";
const SUB_CATEGORY_FILTER_NAME = "subcategory";

export const InvestmentOfferListMobileFilters = form((props: IProps) => {
    const theme = useTheme();

    const categorySelectProps = props.getFieldProps(CATEGORY_FILTER_NAME);
    const subCategorySelectProps = props.getFieldProps(SUB_CATEGORY_FILTER_NAME);
    const subCategoryFinalProps = subCategorySelectProps.value
        ? subCategorySelectProps
        : {...subCategorySelectProps, value: investmentOfferHolidayTypes[0].slug};

    const isAbroad = categorySelectProps.value === InvestmentOfferTypeSlug.ABROAD;

    const categoryOptions = investmentOfferTypes.map((type) => ({
        value: type.slug,
        isActive: type.slug === categorySelectProps.value,
        label: type.namePlural
    }));
    const subCategoryOptions = getInvestmentOffersSubCategoryOptions(categorySelectProps.value as InvestmentOfferTypeSlug);

    return (
        <div css={investmentOfferListMobileFilters}>
            <div css={filtersWrapper}>
                {!isAbroad && <SelectGroupField {...categorySelectProps} options={categoryOptions} name={CATEGORY_FILTER_NAME} />}
                <div css={isAbroad ? mt(0) : mt(4)}>
                    <Text as="label" color={theme.colors.gray[700]} variant="body_copy_1">
                        Lokalizacja
                    </Text>

                    <div css={subCategoryOptionsList}>
                        {subCategoryOptions.map(({value, label}) => {
                            return (
                                <Radio
                                    key={value}
                                    id={value || "all"}
                                    name={SUB_CATEGORY_FILTER_NAME}
                                    isActive={subCategoryFinalProps.value === value}
                                    value={value}
                                    labelContent={label}
                                    onChange={(name: string, _: boolean, value: string | number | boolean) =>
                                        subCategoryFinalProps.onChange(name, value as InvestmentOfferSubCategory)
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            </div>

            <div css={filtersFooterWrapper}>
                <FilterFooter onCancel={props.onReset} onSave={props.onSave} />
            </div>
        </div>
    );
});

const investmentOfferListMobileFilters = () => css`
    ${p(3, 1.5)};
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const filtersWrapper = css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    ${prettyScroll()};
`;

const filtersFooterWrapper = css`
    width: 100%;
    ${pv(3)};
`;

const subCategoryOptionsList = css`
    ${pl(2)};
    ${mt(4)};
    ${flex()};
    flex-direction: column;
    row-gap: 2.4rem;
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {flex, mt, p, pl, prettyScroll, pv} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";
import {SelectGroupField} from "@pg-design/select-group-module";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {
    investmentOfferHolidayTypes,
    InvestmentOfferSubCategory,
    investmentOfferTypes,
    InvestmentOfferTypeSlug
} from "../../constants/investment_offer_constants";
import {IInvestmentOfferListFiltersFields} from "../../hooks/use_investment_offer_filters";
import {getInvestmentOffersSubCategoryOptions} from "../utils/get_investment_offers_subcategory_options";

interface IProps extends IFormProps<IInvestmentOfferListFiltersFields> {
    onReset: () => void;
    onSave: () => void;
}

const CATEGORY_FILTER_NAME = "category";
const SUB_CATEGORY_FILTER_NAME = "subcategory";

export const InvestmentOfferListMobileFilters = form((props: IProps) => {
    const theme = useTheme();

    const categorySelectProps = props.getFieldProps(CATEGORY_FILTER_NAME);
    const subCategorySelectProps = props.getFieldProps(SUB_CATEGORY_FILTER_NAME);
    const subCategoryFinalProps = subCategorySelectProps.value
        ? subCategorySelectProps
        : {...subCategorySelectProps, value: investmentOfferHolidayTypes[0].slug};

    const isAbroad = categorySelectProps.value === InvestmentOfferTypeSlug.ABROAD;

    const categoryOptions = investmentOfferTypes.map((type) => ({
        value: type.slug,
        isActive: type.slug === categorySelectProps.value,
        label: type.namePlural
    }));
    const subCategoryOptions = getInvestmentOffersSubCategoryOptions(categorySelectProps.value as InvestmentOfferTypeSlug);

    return (
        <div css={investmentOfferListMobileFilters}>
            <div css={filtersWrapper}>
                {!isAbroad && <SelectGroupField {...categorySelectProps} options={categoryOptions} name={CATEGORY_FILTER_NAME} />}
                <div css={isAbroad ? mt(0) : mt(4)}>
                    <Text as="label" color={theme.colors.gray[700]} variant="body_copy_1">
                        Lokalizacja
                    </Text>

                    <div css={subCategoryOptionsList}>
                        {subCategoryOptions.map(({value, label}) => {
                            return (
                                <Radio
                                    key={value}
                                    id={value || "all"}
                                    name={SUB_CATEGORY_FILTER_NAME}
                                    isActive={subCategoryFinalProps.value === value}
                                    value={value}
                                    labelContent={label}
                                    onChange={(name: string, _: boolean, value: string | number | boolean) =>
                                        subCategoryFinalProps.onChange(name, value as InvestmentOfferSubCategory)
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            </div>

            <div css={filtersFooterWrapper}>
                <FilterFooter onCancel={props.onReset} onSave={props.onSave} />
            </div>
        </div>
    );
});

const investmentOfferListMobileFilters = () => css`
    ${p(3, 1.5)};
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const filtersWrapper = css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    ${prettyScroll()};
`;

const filtersFooterWrapper = css`
    width: 100%;
    ${pv(3)};
`;

const subCategoryOptionsList = css`
    ${pl(2)};
    ${mt(4)};
    ${flex()};
    flex-direction: column;
    row-gap: 2.4rem;
`;
